export default __webpack_public_path__ + "static/media/banker_3.84ede531.mp3";